import { render, staticRenderFns } from "./rekomendasi-menu.vue?vue&type=template&id=360308d4&"
import script from "./rekomendasi-menu.vue?vue&type=script&lang=js&"
export * from "./rekomendasi-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CIcon: require('@chakra-ui/vue').CIcon, CButton: require('@chakra-ui/vue').CButton, CText: require('@chakra-ui/vue').CText, CImage: require('@chakra-ui/vue').CImage})
